module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-58.4fd3b7e9.svg";